import React from 'react';
import LanguageSelector, { LanguageLink } from '~/components/language-selector/language-selector';
import useLanguageContext from '~/contexts/language';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
export default function TranslationSelector({ translations }) {
    const otherLocales = React.useMemo(() => (translations.length ? translations.map((t) => t.locale) : []), [translations]);
    const translationSlug = React.useCallback((locale) => { var _a; return (_a = translations.find((t) => t.locale === locale)) !== null && _a !== void 0 ? _a : {}; }, [translations]);
    const LinkPresentation = React.useCallback(({ locale }) => {
        const { slug } = translationSlug(locale);
        if (!slug) {
            return null;
        }
        return React.createElement(LanguageLink, { locale: locale, slug: slug });
    }, [translationSlug]);
    useNavigateOnLanguageChange(translationSlug);
    return (React.createElement("section", { className: 'language-selector-section' },
        React.createElement("div", { className: 'content' },
            React.createElement(LanguageSelector, { LeadIn: LeadIn, otherLocales: otherLocales, LinkPresentation: LinkPresentation }),
            React.createElement("div", { className: 'language-selector' },
                React.createElement("span", null,
                    React.createElement(PolishLeadIn, null),
                    ' ',
                    React.createElement(LanguageLink, { locale: 'pl', slug: '' }))))));
}
function PolishLeadIn() {
    return (React.createElement(FormattedMessage, { id: 'weAlsoHave', defaultMessage: 'We also have books in' }));
}
function LeadIn() {
    return (React.createElement(FormattedMessage, { id: 'pageAvailableIn', defaultMessage: 'This page is available in' }));
}
function useNavigateOnLanguageChange(translationSlug) {
    const { language } = useLanguageContext();
    const navigate = useNavigate();
    React.useEffect(() => {
        const slug = translationSlug(language).slug;
        if (slug) {
            navigate(`/subjects/${slug.replace('-books', '')}`, {
                replace: true
            });
        }
    }, [language, translationSlug, navigate]);
}
